/**
 * http://multiple-select.wenzhixin.net.cn/
 */

import $ from "jquery";
window.$ = $;
require("multiple-select/dist/multiple-select.js");

$(window).on("load gform_page_loaded", function () {
	$(".multiple-select select").each(function () {
		// Skip multipleSelect elements. Do not apply multipleSelect more than once. Otherwise, use multipleSelect( 'destroy' ) first.
		if ($(this).hasClass("ms-offscreen")) {
			return;
		}

		var $select = $(this)
			.multipleSelect({
				animate: "slide",
				styler: function (row) {
					if (undefined === row._data || !row._data.icon) {
						return;
					}

					return "background-image: url('" + row._data.icon + "');";
				},
				minimumCountSelected: 1,
				selectAll: false,
				maxHeight: "auto",
				formatAllSelected: function () {
					return "Alle valgt";
				},
				formatCountSelected: function (selected, total) {
					return "%1$d av %2$d valgte"
						.replace("%1$d", selected)
						.replace("%2$d", total);
				},
			})
			.on("change", function () {
				// Get selected option.
				var selected = $(this).children("option:selected");

				if (!selected) {
					return;
				}

				// Get icon from data attribute.
				var icon = selected.data("icon");

				if (icon) {
					// Replace icon.
					$(this)
						.parent()
						.find("button.ms-choice")
						.css("background-image", "url('" + icon + "')");
				}
			});

		var $options = $(this).multipleSelect("getOptions");

		// Replace a default showClear option.
		// Apply only to multiple-type select elements.
		if ($(this).prop("multiple") && $options.showClear) {
			// Create reset button.
			const reset_text_translatable = aptumisticChild.reset_text_translatable;
			var reset = $(
				'<button type="button" class="ms-drop__option--reset">' +
					reset_text_translatable +
					"</button>"
			).on("click", function () {
				$select.multipleSelect("uncheckAll");
			});

			// Create close button.
			/* Find text to translate */
			const close_text_translatable = aptumisticChild.close_text_translatable;
			var close = $(
				'<button type="button" class="ms-drop__option--close">' +
					close_text_translatable +
					"</button>"
			).on("click", function () {
				$select.multipleSelect("close");
			});

			// Create an option containing reset and close buttons and add it to the dropdown as a last element.
			$(this)
				.siblings(".ms-parent")
				.find(".ms-drop ul")
				.append($('<li class="ms-drop__option">').append(reset).append(close));
		}
	});
});
